export const SOCIAL_LOGIN = {
  SOCIAL_LOGIN_REQUEST: 'SOCIAL_LOGIN_REQUEST',
  SOCIAL_LOGIN_SUCCESS: 'SOCIAL_LOGIN_SUCCESS',
  SOCIAL_LOGIN_FAILURE: 'SOCIAL_LOGIN_FAILURE',
};